import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
// eslint-disable-next-line no-unused-vars
import es from "@ckeditor/ckeditor5-build-classic/build/translations/es";

import { Button, Container, Paper, Stack, Typography } from "@mui/material";
import "./editor.styles.css";
import { useCreateLanding } from "../../data/landing/hooks";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useRef } from "react";

const config = {
  language: "es",
  placeholder: "Cree aquí la landing page!",
  toolbar: [
    "undo",
    "redo",
    "|",
    "heading",
    "|",
    "bold",
    "italic",
    "fontColor",
    "fontSize",
    "alignment",
    "|",
    "bulletedList",
    "numberedList",
    "blockQuote",
    "insertTable",
    "|",
    "Link",
    "mediaEmbed",
  ],
  alignment: {
    options: ["left", "center", "right"],
  },
  mediaEmbed: {
    previewsInData: true,
  },
  list: {
    items: "bulletedList,numberedList",
  },
};

const Editor = () => {
  const navigate = useNavigate();
  const [editorState, setEditorState] = useState("");
  const [showPreview, setShowPreview] = useState(true);
  const [transformedEditorState, setTransformedEditorState] = useState();

  const transformContentForPreview = (content) => {
    const transformedContentWithIframes = content.replaceAll(
      /<figure class="media"><oembed url="(.*?)"><\/oembed><\/figure>/gi,
      '<iframe width="560" height="315" src="$1" title="YouTube Video" allowFullScreen></iframe>'
    );

    const transformedContentWithImages = transformedContentWithIframes.replace(
      /<a href="(.*?)(#(\d+))?">(.*?)<\/a>/gi,
      (match, url, _, width, alt) => {
        if (url.startsWith("#")) {
          url = url.substring(1);
          const linkText = alt ? alt : "click aquí";
          return `<a href="${url}">${linkText}</a>`;
        } else {
          return `<img src="${url}" alt="${alt}" style="width: 100%; min-width: 0;" />`;
        }
      }
    );

    return transformedContentWithImages;
  };

  const togglePreview = () => {
    const transformedContent = transformContentForPreview(editorState);
    setTransformedEditorState(transformedContent);
    setShowPreview(!showPreview);
  };

  const {
    handleCreateLanding,
    errorCreate,
    responseCreate,
    response,
    fetchLandingContent,
  } = useCreateLanding();

  const handleSave = async () => {
    await handleCreateLanding(transformedEditorState);
  };

  useEffect(() => {
    if (errorCreate) {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: "Ha habido un error al guardar",
        icon: "error",
        iconColor: "#FF7765",
      });
    }
    if (responseCreate) navigate("/");
  }, [errorCreate, responseCreate, navigate]);

  useEffect(() => {
    fetchLandingContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (response?.response?.htmlString)
      setEditorState(response?.response?.htmlString);
  }, [response]);

  const editorRef = useRef();

  return (
    <Container>
      <Paper elevation={0} mb={1}>
        <Typography variant="h5" component="h2" gutterBottom>
          Editar Landing Page --
        </Typography>
        <CKEditor
          onReady={(editor) => {
            editor.ui
              .getEditableElement()
              .parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
              );

            editorRef.current = editor;
          }}
          data={editorState}
          onChange={(event, editor) => {
            const data = editor.getData();
            setEditorState(data);
            if (showPreview) {
              const transformedContent = transformContentForPreview(data);
              setTransformedEditorState(transformedContent);
            }
          }}
          editor={DecoupledEditor}
          config={config}
        />
        <Stack>
          <Typography variant="caption" fontSize="11px" gutterBottom>
            *Para poner enlaces a web externas poner # delante de la URL
            (#https://), si quieres poner imágenes, sólo la url de la imagen
          </Typography>
        </Stack>
        <Stack direction="row" gap={2} mt={2} mb={2} justifyContent="flex-end">
          <Button onClick={togglePreview} color="primary" variant="contained">
            {!showPreview
              ? "Mostrar Previsualización"
              : "Cerrar previsualización"}
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Guardar
          </Button>
        </Stack>
        {showPreview && (
          <>
            <Typography variant="h5" component="h2" gutterBottom>
              Vista previa
            </Typography>
            <div className="editor-preview border">
              <div
                className="preview-item"
                dangerouslySetInnerHTML={{ __html: transformedEditorState }}
              />
            </div>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default Editor;
